import { SEEducationDetails, SERecognitionApplication } from "../types/seRecognitionTypes";
import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialSEOfficialNoteApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import React from "react";
import { initialSeRecognitionEducation } from "./seRecognitionInitialValues";
import SERecognitionStepApplicant from "../views/components/services/secondaryEducation/form/applicant/SERecognitionStepApplicant";
import SeOfficialNoteStepEducation from "../views/components/services/secondaryEducation/form/education/SeOfficialNoteStepEducation";
import SEOfficialNoteStepDocuments from "../views/components/services/secondaryEducation/form/documents/SEOfficialNoteStepDocuments";
import SEOfficialNoteStepFiling from "../views/components/services/secondaryEducation/form/filing/SEOfficialNoteStepFiling";
import SEOfficialNoteStepApplicant from "../views/components/services/secondaryEducation/form/applicant/SEOfficialNoteStepApplicant";

export const initialSeOfficialNoteEducation: SEEducationDetails = {
  ...initialSeRecognitionEducation,
  hasCertificate: false,
  hasOfficialNote: true,
};

export const initialSeOfficialNoteApplication: SERecognitionApplication = {
  educationDetails: initialSeOfficialNoteEducation,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialSEOfficialNoteApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <SEOfficialNoteStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.education",
      completed: false,
      component: <SeOfficialNoteStepEducation />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <SEOfficialNoteStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <SEOfficialNoteStepFiling />,
      isEdited: false,
    },
  ],
};
